module.exports = __webpack_public_path__ + "timeline_arrow.97160cb6.png";